import React, { useState, useMemo} from 'react'
import Image from 'next/image'

import { Carousel, CarouselNext, CarouselPrev } from "..";
import { Image as ImageInf } from 'src/packages/domain';
import useScrollPosition from '../../lib/useScrollPostition'


type Props = {
    gallery: ImageInf[]
}

const IMAGE_PRIORITY_SCROLL_THRESHOLD = 1500

const sliderSettings = {
    lazyLoad: "progressive",
    centerMode: true,
    centerPadding: "0",
    dots: false,
    easing: "fade-in-out",
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <CarouselNext />,
    prevArrow: <CarouselPrev />
}

const Gallery = ({gallery}: Props) => {

    const scrollPosition = useScrollPosition()
    const imageHighPriority = useMemo(
        ()=>(scrollPosition.top > IMAGE_PRIORITY_SCROLL_THRESHOLD),
        [scrollPosition]
    )

    return (
        <>
            {gallery && 
                <Carousel {...sliderSettings}>
                    
                    {gallery.map((image,i) => (
                        <div className="relative flex h-1/2vh md:h-3/4vh xl:h-600 w-full" key={i} >
                            <Image 
                                src={image.src}
                                alt={image.alt || "art"}
                                priority={imageHighPriority}
                                loading={imageHighPriority ? "eager" : "lazy"}                                
                                fill
                                style={{objectFit: "contain"}}
                            />
                        </div>
                    ))}
                </Carousel>
            }
        </>
    )
}

export default Gallery